<template>
  <!-- Sidebar Nav -->
  <div class="collapse navbar-collapse h-100vh" id="sidebar-nav">
    <div class="js-scrollbar duik-sidebar-sticky duik-sidebar-sticky--mini h-100vh" style="padding-bottom: 100px;">
      <ul class="duik-sidebar__nav">
        <li v-show="item.parent_id == '0'" v-for="item in menus" :key="item.id" class="duik-sidebar__item"><a :class="'duik-sidebar__link' + item.active_menu_link" :href="item.fullUrl">{{ item.menu_title }}</a>
          <ul class="duik-sidebar__nav">
            <li v-show="it.parent_id == item.id" v-for="it in menus" :key="it.id" class="duik-sidebar__item"><a :class="'duik-sidebar__link' + it.active_menu_link" :href="it.fullUrl">{{ it.menu_title }}</a></li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
  <!-- End Sidebar Nav -->
</template>

<script>
import axios from 'axios'

export default {
  data() {
    return {
      loading: true,
      menus: [],
    }
  },
  methods: {
    async getItems() {
      try {
        this.loading = true;
        const {data} = await axios.get(`${process.env.VUE_APP_API}/api/v1/docs`)
        this.menus = data.items;
        this.opened_sections = [];
        data.items.forEach(element => {
          element.active_menu_link = '';
          if ((element.fullUrl == this.$route.path || element.fullUrl.substr(0,element.fullUrl.lastIndexOf('/')) == this.$route.path) || (this.$route.path == '/' && element.fullUrl == '/')) {
            element.active_menu_link = ' active';
          }
        });
        this.loading = false;
      } catch (e) {
        if (e.response && e.response.status == 403) {
          this.loading = true;
          this.$notify.error({
            title: '403 - Доступ запрещён!',
            message: 'У Вас нет прав для доступа к странице'
          });
        }
      }
    },
    menuLink(url) {
      let link = url + 'index.html';
      if (url == '/') {
        link = url;
      }
      return link;
    },
  },
  mounted() {
    this.getItems();
  },
}
</script>

<style lang="scss">
.duik-sidebar__item {
  font-weight: normal;
}
</style>